import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './FeatureCommunity.module.css';
import img from '../assets/4.jpg';

const FeatureCommunity = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"]
  });
  
  const yImage = useTransform(scrollYProgress, [0, 1], [-60, 60]);
  const scaleImage = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const scaleText = useTransform(scrollYProgress, [0, 1], [0.95, 1.05]);

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.container}>
        <motion.div 
          className={styles.textContent}
          style={{ scale: scaleText }}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className={styles.eyebrow}>COMMUNITY</div>
          <h2 className={styles.title}>You map. They see.<br/>Everyone knows.</h2>
          <p className={styles.body}>
            Contribute under your chosen nickname or stay anonymous. No account needed to explore. Every pin on the map is a real person, in a real place, at a real moment.
          </p>
        </motion.div>

        <motion.div 
          className={styles.imageWrapper}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <motion.div 
            className={styles.imageInner}
            style={{ 
              backgroundImage: `url(${img})`,
              y: yImage,
              scale: scaleImage
            }}
          />
          <div className={styles.imageGradientTop} />
        </motion.div>
      </div>
    </section>
  );
};

export default FeatureCommunity;
